import { IPD_COLORS, cardSx, cardShadowHover, toolbarSx } from '../../theme';

export const fadeInSx = {
  animation: 'pharmacyFadeIn 0.35s ease-out',
  '@keyframes pharmacyFadeIn': {
    from: { opacity: 0, transform: 'translateY(6px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
};

export const heroBannerSx = {
  ...cardSx,
  p: { xs: 2, sm: 2.5 },
  mb: 3,
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  background: `linear-gradient(135deg, ${IPD_COLORS.primary} 0%, ${IPD_COLORS.primaryLight} 100%)`,
  border: 'none',
  color: '#fff',
  overflow: 'hidden',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    right: -20,
    top: -20,
    width: 140,
    height: 140,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.06)',
    pointerEvents: 'none',
  },
};

export const filterBarSx = {
  ...toolbarSx,
  mb: 2.5,
};

export const lineTableSx = {
  '& .MuiTable-root': { borderCollapse: 'separate', borderSpacing: 0 },
  '& thead th': {
    borderColor: IPD_COLORS.border,
    color: IPD_COLORS.textSecondary,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    backgroundColor: IPD_COLORS.panelHeaderBg,
    py: 1.25,
    whiteSpace: 'nowrap',
  },
  '& tbody td': {
    borderColor: IPD_COLORS.border,
    color: IPD_COLORS.textPrimary,
    py: 1.25,
    verticalAlign: 'middle',
  },
  '& tbody tr': {
    transition: 'background-color 0.15s ease',
    '&:hover': { backgroundColor: IPD_COLORS.selectedBg },
  },
  '& tbody tr:last-child td': { borderBottom: 'none' },
};

export const contextFieldSx = {
  px: 1.75,
  py: 1.25,
  border: `1px solid ${IPD_COLORS.border}`,
  borderRadius: '10px',
  backgroundColor: IPD_COLORS.panelHeaderBg,
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    borderColor: IPD_COLORS.borderHover,
    boxShadow: IPD_COLORS.shadow.field,
  },
};

export const quickActionSx = (toneColor) => ({
  ...cardSx,
  p: 2,
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.5,
  cursor: 'pointer',
  transition: 'all 0.25s ease',
  borderColor: IPD_COLORS.border,
  '&:hover': {
    borderColor: toneColor,
    boxShadow: cardShadowHover,
    transform: 'translateY(-2px)',
    '& .pharmacy-action-icon': {
      backgroundColor: `${toneColor}22`,
      transform: 'scale(1.05)',
    },
  },
});

export const summaryHighlightSx = {
  ...cardSx,
  p: 2.5,
  background: `linear-gradient(145deg, ${IPD_COLORS.selectedBg} 0%, ${IPD_COLORS.cardBg} 100%)`,
  borderColor: IPD_COLORS.selectedBorder,
};

export const alertBannerSx = (tone = 'error') => {
  const palette = tone === 'error' ? IPD_COLORS.error : IPD_COLORS.warning;
  return {
    ...cardSx,
    p: 1.75,
    mb: 2.5,
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    backgroundColor: palette.bg,
    borderColor: palette.border,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: cardShadowHover,
      borderColor: palette.text,
    },
  };
};

export const pharmacyTabBarSx = {
  display: 'flex',
  gap: 0.5,
  mb: 2.5,
  p: 0.5,
  borderRadius: '12px',
  backgroundColor: IPD_COLORS.panelHeaderBg,
  border: `1px solid ${IPD_COLORS.border}`,
  overflowX: 'auto',
  flexWrap: { xs: 'nowrap', lg: 'wrap' },
  '&::-webkit-scrollbar': { height: 4 },
};

export const pharmacyTabSx = (active, disabled = false) => ({
  px: { xs: 1.5, sm: 2 },
  py: 1,
  borderRadius: '10px',
  cursor: disabled ? 'not-allowed' : 'pointer',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  fontSize: 13,
  fontWeight: active ? 700 : 500,
  color: disabled ? IPD_COLORS.textMuted : (active ? IPD_COLORS.primary : IPD_COLORS.textSecondary),
  backgroundColor: active ? IPD_COLORS.cardBg : 'transparent',
  border: active ? `1px solid ${IPD_COLORS.selectedBorder}` : '1px solid transparent',
  boxShadow: active ? IPD_COLORS.shadow.field : 'none',
  opacity: disabled ? 0.55 : 1,
  transition: 'all 0.2s ease',
  pointerEvents: disabled ? 'none' : 'auto',
  '&:hover': disabled ? {} : {
    color: IPD_COLORS.primary,
    backgroundColor: active ? IPD_COLORS.cardBg : IPD_COLORS.selectedBg,
  },
});

export const selectedRowSx = (selected) => ({
  cursor: 'pointer',
  backgroundColor: selected ? IPD_COLORS.selectedBg : 'transparent',
  '&:hover': { backgroundColor: IPD_COLORS.selectedBg },
});
